import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { TableWidgetRow } from "@hatch-digital-nl/abs-storybook/legacy";
import eyeImage from "../../../common/images/eye.svg";
import downloadImage from "../../../common/images/download.svg";
import { openFileInNewTab } from "../../../common/utils/openFileInNewTab";
import { downloadFile } from "../../../common/utils/downloadFile";

interface Args {
    achievedCertificates: CertificateInterface[];
}

export const mapAchievedCertificatesDataToRows = (
    args: Args,
): TableWidgetRow[] => {
    return args.achievedCertificates.map((achievedCertificate) => {
        const { file_url: fileUrl, file_name: fileName } =
            achievedCertificate.certificate_file ?? {};

        return [
            {
                value: achievedCertificate.qualification.name,
            },
            fileUrl
                ? {
                      content: (
                          <div className="c-table-widget__actions">
                              <button
                                  type="button"
                                  className="u-unstyled-button c-table-widget__actions__button"
                                  onClick={() => {
                                      void openFileInNewTab(fileUrl);
                                  }}
                              >
                                  Bekijken <img src={eyeImage} alt="" />
                              </button>
                              <button
                                  type="button"
                                  className="u-unstyled-button c-table-widget__actions__button"
                                  onClick={() => {
                                      void downloadFile(
                                          fileUrl,
                                          fileName ?? "certificate",
                                      );
                                  }}
                              >
                                  Download <img src={downloadImage} alt="" />
                              </button>
                          </div>
                      ),
                  }
                : {
                      value: "Geen certificaat geüpload",
                  },
        ];
    });
};
